import { createTheme } from "@mui/material";

export const theme = createTheme({
  palette: {
    primary: {
      main: "#27374d",
    },
    secondary: {
      main: "rgb(25, 118, 210)",
    },
    info: {
      main: "#dde6ed",
    },
  },

  typography: {
    fontFamily: "DM Sans",
    // Base size for rem-based text (body, buttons, inputs, tables). MUI's default 14 reads heavy in DM Sans.
    fontSize: 13,
  },

  components: {
    MuiButton: {
      styleOverrides: { root: { textTransform: "none", fontWeight: 600 } },
    },
    MuiTab: {
      styleOverrides: { root: { textTransform: "none" } },
    },
    MuiTooltip: {
      styleOverrides: { tooltip: { fontSize: 12 } },
    },
  },
});
